import { __rest } from "tslib";
import { useFocusable } from '../../interactions/focusable';
import { usePress } from '../../interactions/press';
import { mergeProps } from '../../libs/merge-props';
import { isFirefox } from '../../libs/platform';
export function useButton(props, ref) {
    var _a = props.as, elementType = _a === void 0 ? 'button' : _a, disabled = props.disabled, href = props.href, target = props.target, rel = props.rel, _b = props.type, type = _b === void 0 ? 'button' : _b, tabIndex = props.tabIndex, _onPress = props.onPress, _onPressEnd = props.onPressEnd, _onPressStart = props.onPressStart, _onPressUp = props.onPressUp, _preventFocusOnPress = props.preventFocusOnPress, restProps = __rest(props, ["as", "disabled", "href", "target", "rel", "type", "tabIndex", "onPress", "onPressEnd", "onPressStart", "onPressUp", "preventFocusOnPress"]);
    var additionalProps;
    if (elementType === 'button') {
        additionalProps = { type: type, disabled: disabled };
        if (isFirefox()) {
            // https://bugzilla.mozilla.org/show_bug.cgi?id=654072
            additionalProps.autoComplete = 'off';
        }
    }
    else {
        additionalProps = {
            role: 'button',
            tabIndex: disabled ? undefined : 0,
            href: elementType === 'a' && disabled ? undefined : href,
            target: elementType === 'a' ? target : undefined,
            type: elementType === 'input' ? type : undefined,
            disabled: elementType === 'input' ? disabled : undefined,
            'aria-disabled': !disabled || elementType === 'input' ? undefined : disabled,
            rel: elementType === 'a' ? rel : undefined,
        };
    }
    var focusableProps = useFocusable(props, ref).focusableProps;
    var _c = usePress(props), isPressed = _c.isPressed, pressProps = _c.pressProps;
    return {
        buttonProps: mergeProps(restProps, additionalProps, focusableProps, pressProps),
        ElementType: elementType,
        isPressed: isPressed,
    };
}
